import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import _omit from 'lodash/omit';

class AudioElement extends Component {
  componentWillUnmount() {
    if (this.element && this.element.pause) {
      // WEB-2927
      this.element.src = '';
      this.element.pause();
    }
  }

  render() {
    const safeProps = _omit(this.props, ['audioOutputDevice', 'audioOutputDeviceId', 'dispatch']);
    return (
      <audio
        {...safeProps}
        ref={(element) => {
          if (element) {
            this.element = element;
            if (this.props.audioOutputDeviceId && element.setSinkId) {
              element.setSinkId(this.props.audioOutputDeviceId);
            }
          }
        }}
      />);
  }
}

AudioElement.propTypes = {
  autoPlay: PT.bool,
  loop: PT.bool,
  src: PT.string,
  audioOutputDeviceId: PT.string
};

export default AudioElement;
